import React from 'react'
import { StandaloneSpeakerCard } from 'theme/components/molecules/speaker/speakerCard'

const SpeakersList = ({ speakers, compact = false }) => {
  return (
    <div className={`mt-6 grid grid-cols-1  ${compact ? '' : 'sm:grid-cols-2 lg:grid-cols-3  gap-6'}`}>
      {speakers.map((speaker, index) => {
        return <StandaloneSpeakerCard key={speaker.id} speaker={speaker} index={index} />
      })}
    </div>
  )
}

export default SpeakersList
